import { useParams } from "react-router-dom";

import Button from "@/components/Button";
import useReorderItems from "@/hooks/useReorderItems";
import { useReorderCourseLectureItems } from "../hooks/useReorderCourseLectureItems";

import ItemList from "./ItemList";

function ReorderLectureItems({ lectureItems, onCloseModal }) {
    const { lectureId, courseId } = useParams();

    const {
        items,
        onDragStart,
        onDragOver,
        onDrop,
        onTouchStart,
        onTouchMove,
        onTouchEnd,
    } = useReorderItems(lectureItems);

    const { reorderCourseLectureItems } = useReorderCourseLectureItems();

    function onSubmit(items) {
        const reorderedItems = {
            reorder: items.map((item, index) => ({
                id: item.id,
                position: index + 1,
            })),
        };
        reorderCourseLectureItems(
            { courseId, lectureId, reorderedItems },
            {
                onSuccess: () => {
                    onCloseModal?.();
                },
            }
        );
    }
    return (
        <>
            <p className="text-lg font-medium text-center">
                ترتيب محتويات المحاضره
            </p>
            <ul>
                {items.map((item, index) => (
                    <ItemList
                        key={index}
                        item={item}
                        position={index}
                        onDragStart={() => onDragStart(index)}
                        onDragOver={() => onDragOver(index)}
                        onDrop={onDrop}
                        onTouchStart={() => onTouchStart(index)}
                        onTouchMove={(e) => onTouchMove(e, index)}
                        onTouchEnd={onTouchEnd}
                        data-index={index} // to help identify the target element during touchmove
                    />
                ))}
            </ul>
            <Button
                type="bordered"
                className="w-full text-white bg-secondary-color hover:bg-blue-color-dark"
                onClick={() => {
                    onSubmit(items);
                }}
            >
                تأكيد
            </Button>
            <Button
                type="bordered"
                className="w-full mt-3 text-red-500 bg-white border-red-500 hover:bg-red-600"
                onClick={() => onCloseModal?.()}
            >
                إلغاء
            </Button>
        </>
    );
}

export default ReorderLectureItems;
